import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24 18.77H0C.11 12.716 5.449 7.821 12 7.821s11.89 4.895 12 10.949M12 0c1.654 0 3 1.403 3 3.128s-1.346 3.129-3 3.129-3-1.403-3-3.128S10.346 0 12 0M0 20.334h24v3.128H0z"
    }, null, -1)
  ]))]))
}
export default { render: render }